"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ExportService", {
    enumerable: true,
    get: function() {
        return ExportService;
    }
});
const _stream = require("stream");
const _common = require("@nestjs/common");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _nocodbsdk = require("nocodb-sdk");
const _papaparse = require("papaparse");
const _xlsx = /*#__PURE__*/ _interop_require_wildcard(require("xlsx"));
const _helpers = require("../../helpers");
const _catchError = require("~/helpers/catchError");
const _dataHelpers = require("~/helpers/dataHelpers");
const _exportImportHelpers = require("~/helpers/exportImportHelpers");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _rowColorViewHelpers = require("~/helpers/rowColorViewHelpers");
const _models = require("~/models");
const _datasservice = require("~/services/datas.service");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _modelUtils = require("~/utils/modelUtils");
const _widgets = require("~/db/widgets");
const _dbHelpers = require("~/helpers/dbHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let ExportService = class ExportService {
    async getDataList(context, param) {
        return this.datasService.dataList(context, param);
    }
    async serializeScripts(context) {
        const serializedScripts = [];
        const scripts = await _models.Script.list(context, context.base_id);
        for (const script of scripts){
            serializedScripts.push({
                title: script.title,
                script: script.script,
                description: script.description,
                meta: script.meta
            });
        }
        return serializedScripts;
    }
    async serializeWorkflows(_context, _param, _req) {
        return [];
    }
    async serializeDashboards(context, param, req) {
        const { idMap } = param;
        const serializedDashboards = [];
        const dashboards = await _models.Dashboard.list(context, context.base_id);
        for (const dashboard of dashboards){
            idMap.set(dashboard.id, `${dashboard.base_id}::${dashboard.id}`);
            await dashboard.getWidgets(context);
            const serializedWidgets = [];
            for (const widget of dashboard.widgets){
                var _filters_children;
                const handler = await (0, _widgets.getWidgetHandler)(context, {
                    widget: widget,
                    req
                });
                const serializedWidget = await handler.serializeOrDeserializeWidget(context, widget, idMap);
                const filters = await _models.Filter.getFilterObject(context, {
                    widgetId: widget.id
                });
                const exportedFilters = [];
                if (filters == null ? void 0 : (_filters_children = filters.children) == null ? void 0 : _filters_children.length) {
                    for (const fl of filters.children){
                        const tempFl = {
                            id: `${idMap.get(widget.id)}::${fl.id}`,
                            fk_column_id: idMap.get(fl.fk_column_id),
                            fk_parent_id: `${idMap.get(widget.id)}::${fl.fk_parent_id}`,
                            is_group: fl.is_group,
                            logical_op: fl.logical_op,
                            comparison_op: fl.comparison_op,
                            comparison_sub_op: fl.comparison_sub_op,
                            value: fl.value
                        };
                        if (tempFl.is_group) {
                            delete tempFl.comparison_op;
                            delete tempFl.comparison_sub_op;
                            delete tempFl.value;
                        }
                        exportedFilters.push(tempFl);
                    }
                }
                serializedWidgets.push(_extends({}, serializedWidget, {
                    filters: exportedFilters
                }));
            }
            serializedDashboards.push({
                id: idMap.get(dashboard.id),
                title: dashboard.title,
                description: dashboard.description,
                order: dashboard.order,
                meta: dashboard.meta,
                widgets: serializedWidgets
            });
        }
        return serializedDashboards;
    }
    async serializeModels(context, param) {
        const { modelIds } = param;
        const excludeData = (param == null ? void 0 : param.excludeData) || false;
        const excludeViews = (param == null ? void 0 : param.excludeViews) || false;
        const excludeHooks = (param == null ? void 0 : param.excludeHooks) || false;
        const excludeRowColorConditions = (param == null ? void 0 : param.excludeRowColorConditions) || false;
        const excludeComments = (param == null ? void 0 : param.excludeComments) || (param == null ? void 0 : param.excludeData) || false;
        const excludePermissions = (param == null ? void 0 : param.excludePermissions) || false;
        const compatibilityMode = (param == null ? void 0 : param.compatibilityMode) || false;
        const serializedModels = [];
        // db id to structured id
        const idMap = new Map();
        const bases = [];
        const sources = [];
        const modelsMap = new Map();
        for (const modelId of modelIds){
            const model = await _models.Model.get(context, modelId);
            let pgSerialLastVal;
            if (!model) return _catchError.NcError.tableNotFound(modelId);
            const fndProject = bases.find((p)=>p.id === model.base_id);
            const base = fndProject || await _models.Base.get(context, model.base_id);
            const fndBase = sources.find((b)=>b.id === model.source_id);
            const source = fndBase || await _models.Source.get(context, model.source_id);
            if (!fndProject) bases.push(base);
            if (!fndBase) sources.push(source);
            if (!modelsMap.has(source.id)) {
                modelsMap.set(source.id, await (0, _exportImportHelpers.generateBaseIdMap)(context, source, idMap));
            }
            await model.getColumns(context);
            model.columns = this.filterOutCrossBaseColumns(model);
            await model.getViews(context);
            // if views are excluded, filter all views except default
            const firstView = (0, _nocodbsdk.getFirstNonPersonalView)(model.views, {
                includeViewType: _nocodbsdk.ViewTypes.GRID
            });
            if (excludeViews) {
                if (firstView) {
                    firstView.is_default = true;
                }
                model.views = firstView ? [
                    firstView
                ] : [];
            } else {
                model.views = model.views.map((view)=>{
                    if (view.id === firstView.id) {
                        view.is_default = true;
                    }
                    return view;
                });
            }
            for (const column of model.columns){
                await column.getColOptions(context);
                // if data is not excluded, get currval for ai column (pg)
                if (!excludeData) {
                    if (source.type === 'pg') {
                        if (column.ai) {
                            try {
                                const baseModel = await _models.Model.getBaseModelSQL(context, {
                                    id: model.id,
                                    viewId: null,
                                    dbDriver: await _NcConnectionMgrv2.default.get(source)
                                });
                                const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
                                const seq = await sqlClient.raw(`SELECT pg_get_serial_sequence('??', ?) as seq;`, [
                                    baseModel.getTnPath(model.table_name),
                                    column.column_name
                                ]);
                                if (seq.rows.length > 0 && seq.rows[0].seq) {
                                    const seqName = seq.rows[0].seq;
                                    const res = await sqlClient.raw(`SELECT last_value as last FROM ${seqName};`);
                                    if (res.rows.length > 0) {
                                        pgSerialLastVal = res.rows[0].last;
                                    }
                                }
                            } catch (e) {
                                this.debugLog(e);
                            }
                        }
                    }
                }
                if (column.colOptions) {
                    for (const [k, v] of Object.entries(column.colOptions)){
                        switch(k){
                            case 'fk_mm_child_column_id':
                            case 'fk_mm_parent_column_id':
                            case 'fk_mm_model_id':
                            case 'fk_parent_column_id':
                            case 'fk_child_column_id':
                            case 'fk_related_model_id':
                            case 'fk_relation_column_id':
                            case 'fk_lookup_column_id':
                            case 'fk_rollup_column_id':
                            case 'fk_qr_value_column_id':
                            case 'fk_barcode_value_column_id':
                            case 'fk_model_id':
                                column.colOptions[k] = idMap.get(v);
                                break;
                            // Preserve the values on export
                            // We will keep these only within same workspace as integration is only available within same workspace
                            case 'fk_workspace_id':
                            case 'fk_integrations_id':
                            case 'model':
                                column.colOptions[k] = v;
                                break;
                            case 'output_column_ids':
                                column.colOptions[k] = ((v == null ? void 0 : v.split(',')) || []).map((id)=>idMap.get(id)).join(',');
                                break;
                            case 'fk_target_view_id':
                                if (v) {
                                    const view = await _models.View.get(context, v);
                                    idMap.set(view.id, `${source.base_id}::${source.id}::${(0, _exportImportHelpers.getEntityIdentifier)(view.fk_model_id)}::${view.id}`);
                                    column.colOptions[k] = idMap.get(v);
                                }
                                break;
                            case 'options':
                                for (const o of column.colOptions['options']){
                                    delete o.id;
                                    delete o.fk_column_id;
                                }
                                break;
                            case 'formula':
                                var _column_colOptions_k, _column_colOptions_k1;
                                if (column.uidt === _nocodbsdk.UITypes.Button) break;
                                // rewrite formula_raw with aliases
                                column.colOptions['formula_raw'] = (_column_colOptions_k = column.colOptions[k]) == null ? void 0 : _column_colOptions_k.replace(/\{\{.*?\}\}/gm, (match)=>{
                                    const col = model.columns.find((c)=>c.id === match.slice(2, -2));
                                    return `{${col == null ? void 0 : col.title}}`;
                                });
                                column.colOptions[k] = (_column_colOptions_k1 = column.colOptions[k]) == null ? void 0 : _column_colOptions_k1.replace(RegExp("(?<=\\{\\{).*?(?=\\}\\})", "gm"), (match)=>idMap.get(match));
                                break;
                            case 'fk_webhook_id':
                                column.colOptions[k] = idMap.get(v);
                                break;
                            case 'fk_script_id':
                                column.colOptions[k] = idMap.get(v);
                                break;
                            case 'id':
                            case 'created_at':
                            case 'updated_at':
                            case 'fk_column_id':
                                delete column.colOptions[k];
                                break;
                        }
                    }
                }
                // pg default value fix
                if (source.type === 'pg') {
                    if (column.cdf) {
                        const cdf = column.cdf.toString();
                        // check if column.cdf has unmatched single quotes
                        const matches = cdf.match(/'/g);
                        if (matches && matches.length % 2 !== 0) {
                            // if so remove after last single quote
                            const lastQuoteIndex = cdf.lastIndexOf("'");
                            column.cdf = cdf.substring(0, lastQuoteIndex);
                        }
                    }
                }
                // Link column filters
                if ((0, _nocodbsdk.isLinksOrLTAR)(column)) {
                    var _column_meta, _colOptions_filter_children, _colOptions_filter;
                    const colOptions = column.colOptions;
                    // if cross base link skip
                    if ((colOptions == null ? void 0 : colOptions.fk_related_base_id) && colOptions.fk_related_base_id !== colOptions.base_id) {
                        continue;
                    }
                    // skip custom link columns
                    if (column == null ? void 0 : (_column_meta = column.meta) == null ? void 0 : _column_meta.custom) {
                        continue;
                    }
                    colOptions.filter = await _models.Filter.getFilterObject(context, {
                        linkColId: column.id
                    });
                    if ((_colOptions_filter = colOptions.filter) == null ? void 0 : (_colOptions_filter_children = _colOptions_filter.children) == null ? void 0 : _colOptions_filter_children.length) {
                        const export_filters = [];
                        for (const fl of colOptions.filter.children){
                            const tempFl = {
                                id: `${idMap.get(column.id)}::${fl.id}`,
                                fk_column_id: idMap.get(fl.fk_column_id),
                                fk_parent_id: `${idMap.get(column.id)}::${fl.fk_parent_id}`,
                                fk_link_col_id: idMap.get(column.id),
                                fk_value_col_id: fl.fk_value_col_id ? idMap.get(fl.fk_value_col_id) : null,
                                is_group: fl.is_group,
                                logical_op: fl.logical_op,
                                comparison_op: fl.comparison_op,
                                comparison_sub_op: fl.comparison_sub_op,
                                value: fl.value
                            };
                            if (tempFl.is_group) {
                                delete tempFl.comparison_op;
                                delete tempFl.comparison_sub_op;
                                delete tempFl.value;
                            }
                            export_filters.push(tempFl);
                        }
                        colOptions.filter.children = export_filters;
                    }
                }
            }
            for (const view of model.views){
                idMap.set(view.id, `${idMap.get(model.id)}::${view.id}`);
                await view.getColumns(context);
                await view.getFilters(context);
                await view.getSorts(context);
                if (view.filter) {
                    const export_filters = [];
                    for (const fl of view.filter.children){
                        const tempFl = {
                            id: `${idMap.get(view.id)}::${fl.id}`,
                            fk_parent_column_id: fl.fk_parent_column_id ? idMap.get(fl.fk_parent_column_id) : null,
                            fk_column_id: idMap.get(fl.fk_column_id),
                            fk_parent_id: `${idMap.get(view.id)}::${fl.fk_parent_id}`,
                            is_group: fl.is_group,
                            logical_op: fl.logical_op,
                            comparison_op: fl.comparison_op,
                            comparison_sub_op: fl.comparison_sub_op,
                            value: fl.value,
                            meta: fl.meta
                        };
                        if (tempFl.is_group) {
                            delete tempFl.comparison_op;
                            delete tempFl.comparison_sub_op;
                            delete tempFl.value;
                        }
                        export_filters.push(tempFl);
                    }
                    view.filter.children = export_filters;
                }
                if (view.sorts) {
                    const export_sorts = [];
                    for (const sr of view.sorts){
                        const tempSr = {
                            fk_column_id: idMap.get(sr.fk_column_id),
                            direction: sr.direction
                        };
                        export_sorts.push(tempSr);
                    }
                    view.sorts = export_sorts;
                }
                if (view.view) {
                    for (const [k, v] of Object.entries(view.view)){
                        switch(k){
                            case 'fk_column_id':
                            case 'fk_cover_image_col_id':
                            case 'fk_grp_col_id':
                            case 'fk_prefix_column_id':
                                view.view[k] = idMap.get(v);
                                break;
                            case 'levels':
                                if (view.type === _nocodbsdk.ViewTypes.LIST) {
                                    view.view[k] = v.map((level)=>{
                                        var _idMap_get, _idMap_get1, _idMap_get2;
                                        return {
                                            level: level.level,
                                            fk_model_id: (_idMap_get = idMap.get(level.fk_model_id)) != null ? _idMap_get : level.fk_model_id,
                                            fk_link_column_id: level.fk_link_column_id ? (_idMap_get1 = idMap.get(level.fk_link_column_id)) != null ? _idMap_get1 : level.fk_link_column_id : null,
                                            fk_self_link_column_id: level.fk_self_link_column_id ? (_idMap_get2 = idMap.get(level.fk_self_link_column_id)) != null ? _idMap_get2 : level.fk_self_link_column_id : null,
                                            enable_nested_records: level.enable_nested_records,
                                            wrap_headers: level.wrap_headers,
                                            meta: level.meta
                                        };
                                    });
                                }
                                break;
                            case 'meta':
                                if (view.type === _nocodbsdk.ViewTypes.KANBAN) {
                                    const meta = (0, _modelUtils.parseMetaProp)(view.view);
                                    for (const [k, v] of Object.entries(meta)){
                                        // keep non-array meta as it is
                                        if (!Array.isArray(v)) continue;
                                        const colId = idMap.get(k);
                                        for (const op of v){
                                            op.fk_column_id = idMap.get(op.fk_column_id);
                                            delete op.id;
                                        }
                                        meta[colId] = v;
                                        delete meta[k];
                                    }
                                    view.view.meta = meta;
                                }
                                break;
                            case 'calendar_range':
                                if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
                                    const range = view.view[k];
                                    view.view[k] = range.map((r)=>{
                                        return {
                                            fk_to_column_id: idMap.get(r.fk_to_column_id),
                                            fk_from_column_id: idMap.get(r.fk_from_column_id)
                                        };
                                    });
                                }
                                break;
                            case 'created_at':
                            case 'updated_at':
                            case 'fk_view_id':
                            case 'base_id':
                            case 'source_id':
                            case 'uuid':
                                delete view.view[k];
                                break;
                        }
                    }
                }
            }
            let serializedRowColorConditions = {
                result: [],
                filters: [],
                rowColorConditions: []
            };
            if (!excludeRowColorConditions) {
                serializedRowColorConditions = await _rowColorViewHelpers.RowColorViewHelpers.withContext(context).getDuplicateRowColorConditions({
                    views: model.views,
                    idMap,
                    mapColumnId: true
                });
            }
            const serializedHooks = [];
            if (!excludeHooks) {
                const hooks = await _models.Hook.list(context, {
                    fk_model_id: model.id
                });
                for (const hook of hooks){
                    var _hookFilters_children;
                    idMap.set(hook.id, `${idMap.get(hook.fk_model_id)}::${hook.id}`);
                    const hookFilters = await _models.Filter.getFilterObject(context, {
                        hookId: hook.id
                    });
                    const export_filters = [];
                    if (hookFilters == null ? void 0 : (_hookFilters_children = hookFilters.children) == null ? void 0 : _hookFilters_children.length) {
                        for (const fl of hookFilters.children){
                            const tempFl = {
                                id: `${idMap.get(hook.id)}::${fl.id}`,
                                fk_column_id: idMap.get(fl.fk_column_id),
                                fk_parent_id: `${idMap.get(hook.id)}::${fl.fk_parent_id}`,
                                is_group: fl.is_group,
                                logical_op: fl.logical_op,
                                comparison_op: fl.comparison_op,
                                comparison_sub_op: fl.comparison_sub_op,
                                value: fl.value
                            };
                            if (tempFl.is_group) {
                                delete tempFl.comparison_op;
                                delete tempFl.comparison_sub_op;
                                delete tempFl.value;
                            }
                            export_filters.push(tempFl);
                        }
                    }
                    serializedHooks.push({
                        id: idMap.get(hook.id),
                        title: hook.title,
                        active: hook.active,
                        condition: hook.condition,
                        event: hook.event,
                        operation: hook.operation,
                        notification: hook.notification,
                        version: hook.version,
                        filters: export_filters
                    });
                }
            }
            const serializedComments = [];
            if (!excludeComments) {
                const READ_BATCH_SIZE = 100;
                const comments = [];
                let offset = 0;
                // eslint-disable-next-line no-constant-condition
                while(true){
                    const batchComments = await _models.Comment.listByModel(context, model.id, {
                        limit: READ_BATCH_SIZE + 1,
                        offset
                    });
                    comments.push(...batchComments.slice(0, READ_BATCH_SIZE));
                    if (batchComments.length <= READ_BATCH_SIZE) break;
                    offset += READ_BATCH_SIZE;
                }
                for (const comment of comments){
                    idMap.set(comment.id, `${idMap.get(model.id)}::${comment.id}`);
                    serializedComments.push({
                        id: idMap.get(comment.id),
                        fk_model_id: idMap.get(comment.fk_model_id),
                        row_id: comment.row_id,
                        comment: comment.comment,
                        parent_comment_id: comment.parent_comment_id ? idMap.get(comment.parent_comment_id) : null,
                        created_by: comment.created_by,
                        resolved_by: comment.resolved_by,
                        created_by_email: comment.created_by_email,
                        resolved_by_email: comment.resolved_by_email
                    });
                }
            }
            const serializedPermissions = [];
            if (!excludePermissions) {
                const basePermissions = await _models.Permission.list(context, model.base_id);
                const fieldIds = model.columns.map((c)=>c.id);
                const modelPermissions = basePermissions.filter((p)=>p.entity === _nocodbsdk.PermissionEntity.TABLE && p.entity_id === model.id || p.entity === _nocodbsdk.PermissionEntity.FIELD && fieldIds.includes(p.entity_id));
                for (const permission of modelPermissions){
                    idMap.set(permission.id, `${idMap.get(permission.entity_id)}::${permission.id}`);
                    serializedPermissions.push({
                        id: idMap.get(permission.id),
                        entity: permission.entity,
                        entity_id: idMap.get(permission.entity_id),
                        permission: permission.permission,
                        enforce_for_form: permission.enforce_for_form,
                        enforce_for_automation: permission.enforce_for_automation,
                        granted_type: permission.granted_type,
                        granted_role: permission.granted_role,
                        subjects: permission.subjects
                    });
                }
            }
            serializedModels.push({
                model: {
                    id: idMap.get(model.id),
                    prefix: base.prefix,
                    title: model.title,
                    table_name: (0, _exportImportHelpers.clearPrefix)(model.table_name, base.prefix),
                    description: model.description,
                    pgSerialLastVal,
                    meta: model.meta,
                    columns: model.columns.map((column)=>{
                        // Exclude constraints field from export (internal field)
                        const { constraints } = column, columnData = _object_without_properties_loose(column, [
                            "constraints"
                        ]);
                        return _extends({
                            description: columnData.description,
                            id: idMap.get(columnData.id),
                            ai: columnData.ai,
                            column_name: columnData.column_name,
                            meta: columnData.meta,
                            pk: columnData.pk,
                            pv: columnData.pv,
                            order: columnData.order,
                            rqd: columnData.rqd,
                            system: columnData.system,
                            uidt: columnData.uidt,
                            title: columnData.title,
                            un: columnData.un,
                            unique: columnData.unique,
                            colOptions: columnData.colOptions
                        }, !compatibilityMode && {
                            cc: columnData.cc,
                            dt: columnData.dt,
                            dtxp: columnData.dtxp,
                            dtxs: columnData.dtxs,
                            cdf: columnData.cdf
                        });
                    })
                },
                views: model.views.map((view)=>({
                        description: view.description,
                        id: idMap.get(view.id),
                        type: view.type,
                        meta: _rowColorViewHelpers.RowColorViewHelpers.withContext(context).mapMetaColumn({
                            meta: view.meta,
                            idMap
                        }),
                        is_default: view.is_default,
                        order: view.order,
                        title: view.title,
                        show: view.show,
                        show_system_fields: view.show_system_fields,
                        filter: view.filter,
                        sorts: view.sorts,
                        lock_type: view.lock_type,
                        owned_by: view.owned_by,
                        row_coloring_mode: view.row_coloring_mode,
                        columns: view.columns.map((column)=>{
                            const { id, fk_view_id, fk_column_id, base_id, source_id, created_at, updated_at, uuid } = column, rest = _object_without_properties_loose(column, [
                                "id",
                                "fk_view_id",
                                "fk_column_id",
                                "base_id",
                                "source_id",
                                "created_at",
                                "updated_at",
                                "uuid"
                            ]);
                            return _extends({
                                fk_column_id: idMap.get(fk_column_id)
                            }, rest);
                        }),
                        view: view.view
                    })),
                rowColorConditions: {
                    filters: serializedRowColorConditions.filters,
                    rowColorConditions: serializedRowColorConditions.rowColorConditions
                },
                hooks: serializedHooks,
                comments: serializedComments,
                permissions: serializedPermissions,
                idMap
            });
        }
        return {
            serializedModels,
            idMap
        };
    }
    async serializeUsers(context, param) {
        const { baseId } = param;
        const base = await _models.Base.get(context, baseId);
        if (!base) return _catchError.NcError.baseNotFound(baseId);
        const users = await _models.BaseUser.getUsersList(context, {
            base_id: base.id
        });
        const serializedUsers = users.map((user)=>({
                email: user.email,
                display_name: user.display_name,
                base_role: user.roles,
                workspace_role: user.workspace_roles
            }));
        return serializedUsers;
    }
    async streamModelDataAsCsv(context, param) {
        context = _extends({}, context, {
            cache: true
        });
        const { dataStream, linkStream, handledMmList } = param;
        const dataExportMode = !linkStream;
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, {
            baseName: param.baseId,
            tableName: param.modelId,
            viewName: param.viewId
        });
        const source = await _models.Source.get(context, model.source_id);
        await model.getColumns(context);
        if (!param.includeCrossBaseColumns) {
            model.columns = this.filterOutCrossBaseColumns(model);
        } else {
            model.columns = [
                ...model.columns
            ];
        }
        const btMap = new Map();
        if (!dataExportMode) {
            for (const column of model.columns.filter((col)=>{
                var _col_colOptions, _col_colOptions1, _col_meta;
                return col.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord && (((_col_colOptions = col.colOptions) == null ? void 0 : _col_colOptions.type) === _nocodbsdk.RelationTypes.BELONGS_TO || ((_col_colOptions1 = col.colOptions) == null ? void 0 : _col_colOptions1.type) === _nocodbsdk.RelationTypes.ONE_TO_ONE && ((_col_meta = col.meta) == null ? void 0 : _col_meta.bt));
            })){
                await column.getColOptions(context);
                const fkCol = model.columns.find((c)=>{
                    var _column_colOptions;
                    return c.id === ((_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.fk_child_column_id);
                });
                if (fkCol) {
                    // replace bt column with fk column if it is in _fieldIds
                    if (param._fieldIds && param._fieldIds.includes(column.id)) {
                        param._fieldIds.push(fkCol.id);
                        const btIndex = param._fieldIds.indexOf(column.id);
                        param._fieldIds.splice(btIndex, 1);
                    }
                    btMap.set(fkCol.id, `${column.base_id}::${column.source_id}::${column.fk_model_id}::${column.id}`);
                }
            }
        }
        let fields = param._fieldIds ? model.columns.filter((c)=>{
            var _param__fieldIds;
            return (_param__fieldIds = param._fieldIds) == null ? void 0 : _param__fieldIds.includes(c.id);
        }).map((c)=>c.title) : model.columns.filter((c)=>!(0, _nocodbsdk.isLinksOrLTAR)(c) && !(0, _nocodbsdk.isVirtualCol)(c)).map((c)=>c.title);
        const refView = view != null ? view : await _models.View.getFirstCollaborativeView(context, model.id);
        const viewCols = await refView.getColumns(context);
        if (dataExportMode) {
            const hideSystemFields = view.show_system_fields ? model.columns.filter((c)=>{
                var _c_colOptions;
                return (0, _nocodbsdk.isSystemColumn)(c) && c.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord && ((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_related_model_id) !== model.id;
            }).map((c)=>c.id) : model.columns.filter((c)=>(0, _nocodbsdk.isSystemColumn)(c)).map((c)=>c.id);
            fields = viewCols.sort((a, b)=>a.order - b.order).filter((c)=>c.show && !hideSystemFields.includes(c.fk_column_id)).map((vc)=>{
                var _model_columns_find;
                return (_model_columns_find = model.columns.find((c)=>c.id === vc.fk_column_id)) == null ? void 0 : _model_columns_find.title;
            })// to filter out undefined values(cross base link)
            .filter(Boolean);
        }
        const mmColumns = param._fieldIds ? model.columns.filter((c)=>{
            var _param__fieldIds;
            return (_param__fieldIds = param._fieldIds) == null ? void 0 : _param__fieldIds.includes(c.id);
        }).filter((col)=>(0, _nocodbsdk.isMMOrMMLike)(col)) : model.columns.filter((col)=>(0, _nocodbsdk.isMMOrMMLike)(col));
        const hasLink = !dataExportMode && mmColumns.length > 0;
        dataStream.setEncoding('utf8');
        const formatData = (data)=>{
            for (const row of data){
                for (const [k, v] of Object.entries(row)){
                    const col = model.columns.find((c)=>c.title === k);
                    if (col) {
                        const colId = `${col.base_id}::${col.source_id}::${col.fk_model_id}::${col.id}`;
                        let skip = false;
                        switch(col.uidt){
                            case _nocodbsdk.UITypes.ForeignKey:
                                {
                                    if (btMap.has(col.id)) {
                                        row[btMap.get(col.id)] = v;
                                        delete row[k];
                                    }
                                }
                                break;
                            case _nocodbsdk.UITypes.Attachment:
                                try {
                                    if (typeof v === 'string') {
                                        try {
                                            JSON.parse(v);
                                            // use v if valid JSON
                                            row[colId] = v;
                                        } catch (ex) {
                                            row[colId] = null;
                                        }
                                    } else {
                                        row[colId] = JSON.stringify(v);
                                    }
                                } catch (e) {
                                    row[colId] = v;
                                }
                                break;
                            case _nocodbsdk.UITypes.LongText:
                                var _col_meta;
                                if (((_col_meta = col.meta) == null ? void 0 : _col_meta[_nocodbsdk.LongTextAiMetaProp]) && v) {
                                    try {
                                        row[colId] = JSON.stringify(v);
                                    } catch (e) {
                                        row[colId] = v;
                                    }
                                } else {
                                    row[colId] = v;
                                }
                                break;
                            case _nocodbsdk.UITypes.User:
                            case _nocodbsdk.UITypes.CreatedBy:
                            case _nocodbsdk.UITypes.LastModifiedBy:
                                // skip populating if excludeUsers is true
                                if (param.excludeUsers === true) {
                                    row[colId] = null;
                                    break;
                                }
                                if (v) {
                                    const userEmails = [];
                                    const userRecord = Array.isArray(v) ? v : [
                                        v
                                    ];
                                    for (const user of userRecord){
                                        userEmails.push(user.email);
                                    }
                                    row[colId] = userEmails.join(',');
                                } else {
                                    row[colId] = v;
                                }
                                break;
                            case _nocodbsdk.UITypes.Formula:
                            case _nocodbsdk.UITypes.Lookup:
                            case _nocodbsdk.UITypes.Button:
                            case _nocodbsdk.UITypes.Rollup:
                            case _nocodbsdk.UITypes.Barcode:
                            case _nocodbsdk.UITypes.QrCode:
                                // skip these types
                                skip = true;
                                break;
                            case _nocodbsdk.UITypes.JSON:
                                try {
                                    row[colId] = JSON.stringify(v);
                                } catch (e) {
                                    // avoid exporting invalid JSON
                                    row[colId] = null;
                                }
                                break;
                            default:
                                row[colId] = v;
                                break;
                        }
                        delete row[k];
                        if (!skip) {
                            // if the value is explicitly empty string preserve it
                            if (v === '') {
                                row[colId] = '__nc_empty_string__';
                            }
                        }
                    }
                }
            }
            return {
                data
            };
        };
        const formatAndSerialize = async (data)=>{
            const includedColumns = [];
            for (const row of data){
                for (const [k, v] of Object.entries(row)){
                    const col = model.columns.find((c)=>c.title === k);
                    if (col) {
                        var _ref;
                        var _viewCols_find;
                        row[k] = await (0, _dataHelpers.serializeCellValue)(context, {
                            value: v,
                            column: col,
                            siteUrl: param.ncSiteUrl
                        });
                        includedColumns.push({
                            col,
                            viewOrder: (_ref = (_viewCols_find = viewCols.find((vCol)=>vCol.fk_column_id === col.id)) == null ? void 0 : _viewCols_find.order) != null ? _ref : includedColumns.length + 1
                        });
                    }
                }
            }
            const orderedColumns = includedColumns.sort((a, b)=>a.viewOrder - b.viewOrder);
            return {
                data: data.map((row)=>{
                    return orderedColumns.reduce((acc, cur)=>{
                        acc[cur.col.title] = row[cur.col.title];
                        return acc;
                    }, {});
                })
            };
        };
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const limit = 200;
        const offset = 0;
        try {
            await this.recursiveRead(context, dataExportMode ? formatAndSerialize : formatData, baseModel, dataStream, model, view, offset, limit, fields, true, param.delimiter, dataExportMode, {
                filterArrJson: param.filterArrJson,
                sortArrJson: param.sortArrJson
            });
        } catch (e) {
            this.debugLog(e);
            throw e;
        }
        if (hasLink) {
            linkStream.setEncoding('utf8');
            let streamedHeaders = false;
            for (const mm of mmColumns){
                var _mm_colOptions, _mm_colOptions1, _mm_colOptions2;
                if (handledMmList.includes((_mm_colOptions = mm.colOptions) == null ? void 0 : _mm_colOptions.fk_mm_model_id)) continue;
                const mmModel = await _models.Model.get(context, (_mm_colOptions1 = mm.colOptions) == null ? void 0 : _mm_colOptions1.fk_mm_model_id);
                await mmModel.getColumns(context);
                mmModel.columns = this.filterOutCrossBaseColumns(mmModel);
                const childColumn = mmModel.columns.find((col)=>{
                    var _mm_colOptions;
                    return col.id === ((_mm_colOptions = mm.colOptions) == null ? void 0 : _mm_colOptions.fk_mm_child_column_id);
                });
                const parentColumn = mmModel.columns.find((col)=>{
                    var _mm_colOptions;
                    return col.id === ((_mm_colOptions = mm.colOptions) == null ? void 0 : _mm_colOptions.fk_mm_parent_column_id);
                });
                const childColumnTitle = childColumn.title;
                const parentColumnTitle = parentColumn.title;
                const mmFields = mmModel.columns.filter((c)=>c.uidt === _nocodbsdk.UITypes.ForeignKey).map((c)=>c.title);
                const mmFormatData = (data)=>{
                    data.map((d)=>{
                        d.column = mm.id;
                        d.child = d[childColumnTitle];
                        d.parent = d[parentColumnTitle];
                        delete d[childColumnTitle];
                        delete d[parentColumnTitle];
                        return d;
                    });
                    return {
                        data
                    };
                };
                const mmLimit = 200;
                const mmOffset = 0;
                const mmBase = mmModel.source_id === source.id ? source : await _models.Source.get(context, mmModel.source_id);
                const mmBaseModel = await _models.Model.getBaseModelSQL(context, {
                    id: mmModel.id,
                    dbDriver: await _NcConnectionMgrv2.default.get(mmBase)
                });
                try {
                    await this.recursiveLinkRead(context, mmFormatData, mmBaseModel, linkStream, mmModel, undefined, mmOffset, mmLimit, mmFields, !streamedHeaders);
                    // avoid writing headers for same model multiple times
                    streamedHeaders = true;
                } catch (e) {
                    this.debugLog(e);
                    throw e;
                }
                handledMmList.push((_mm_colOptions2 = mm.colOptions) == null ? void 0 : _mm_colOptions2.fk_mm_model_id);
            }
            linkStream.push(null);
        } else {
            if (linkStream) linkStream.push(null);
        }
    }
    async streamModelDataAsJson(context, param) {
        context = _extends({}, context, {
            cache: true
        });
        const { dataStream } = param;
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, {
            baseName: param.baseId,
            tableName: param.modelId,
            viewName: param.viewId
        });
        const source = await _models.Source.get(context, model.source_id);
        await model.getColumns(context);
        if (!param.includeCrossBaseColumns) {
            model.columns = this.filterOutCrossBaseColumns(model);
        } else {
            model.columns = [
                ...model.columns
            ];
        }
        let fields = param._fieldIds ? model.columns.filter((c)=>{
            var _param__fieldIds;
            return (_param__fieldIds = param._fieldIds) == null ? void 0 : _param__fieldIds.includes(c.id);
        }).map((c)=>c.title) : model.columns.filter((c)=>!(0, _nocodbsdk.isLinksOrLTAR)(c) && !(0, _nocodbsdk.isVirtualCol)(c)).map((c)=>c.title);
        const refView = view != null ? view : await _models.View.getFirstCollaborativeView(context, model.id);
        const viewCols = await refView.getColumns(context);
        const hideSystemFields = view.show_system_fields ? model.columns.filter((c)=>{
            var _c_colOptions;
            return (0, _nocodbsdk.isSystemColumn)(c) && c.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord && ((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_related_model_id) !== model.id;
        }).map((c)=>c.id) : model.columns.filter((c)=>(0, _nocodbsdk.isSystemColumn)(c)).map((c)=>c.id);
        fields = viewCols.sort((a, b)=>a.order - b.order).filter((c)=>c.show && !hideSystemFields.includes(c.fk_column_id)).map((vc)=>{
            var _model_columns_find;
            return (_model_columns_find = model.columns.find((c)=>c.id === vc.fk_column_id)) == null ? void 0 : _model_columns_find.title;
        })// to filter out undefined values(cross base link)
        .filter(Boolean);
        dataStream.setEncoding('utf8');
        const formatAndSerializeForJson = async (data)=>{
            const includedColumns = [];
            for (const row of data){
                for (const [k, v] of Object.entries(row)){
                    const col = model.columns.find((c)=>c.title === k);
                    if (col) {
                        var _ref;
                        var _viewCols_find;
                        row[k] = await (0, _dataHelpers.serializeCellValue)(context, {
                            value: v,
                            column: col,
                            siteUrl: param.ncSiteUrl
                        });
                        includedColumns.push({
                            col,
                            viewOrder: (_ref = (_viewCols_find = viewCols.find((vCol)=>vCol.fk_column_id === col.id)) == null ? void 0 : _viewCols_find.order) != null ? _ref : includedColumns.length + 1
                        });
                    }
                }
            }
            const orderedColumns = includedColumns.sort((a, b)=>a.viewOrder - b.viewOrder);
            return {
                data: data.map((row)=>{
                    return orderedColumns.reduce((acc, cur)=>{
                        acc[cur.col.title] = row[cur.col.title];
                        return acc;
                    }, {});
                })
            };
        };
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const limit = 200;
        const offset = 0;
        try {
            await this.recursiveReadForJson(context, formatAndSerializeForJson, baseModel, dataStream, model, view, offset, limit, fields, true, {
                filterArrJson: param.filterArrJson,
                sortArrJson: param.sortArrJson
            });
        } catch (e) {
            this.debugLog(e);
            throw e;
        }
    }
    async streamModelDataAsExcel(context, param) {
        context = _extends({}, context, {
            cache: true
        });
        const { dataStream } = param;
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, {
            baseName: param.baseId,
            tableName: param.modelId,
            viewName: param.viewId
        });
        const source = await _models.Source.get(context, model.source_id);
        await model.getColumns(context);
        if (!param.includeCrossBaseColumns) {
            model.columns = this.filterOutCrossBaseColumns(model);
        } else {
            model.columns = [
                ...model.columns
            ];
        }
        const refView = view != null ? view : await _models.View.getFirstCollaborativeView(context, model.id);
        const viewCols = await refView.getColumns(context);
        const hideSystemFields = view.show_system_fields ? model.columns.filter((c)=>{
            var _c_colOptions;
            return (0, _nocodbsdk.isSystemColumn)(c) && c.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord && ((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_related_model_id) !== model.id;
        }).map((c)=>c.id) : model.columns.filter((c)=>(0, _nocodbsdk.isSystemColumn)(c)).map((c)=>c.id);
        const fields = viewCols.sort((a, b)=>a.order - b.order).filter((c)=>c.show && !hideSystemFields.includes(c.fk_column_id)).map((vc)=>{
            var _model_columns_find;
            return (_model_columns_find = model.columns.find((c)=>c.id === vc.fk_column_id)) == null ? void 0 : _model_columns_find.title;
        }).filter(Boolean);
        const formatAndSerialize = async (data)=>{
            const includedColumns = [];
            for (const row of data){
                for (const [k, v] of Object.entries(row)){
                    const col = model.columns.find((c)=>c.title === k);
                    if (col) {
                        var _ref;
                        var _viewCols_find;
                        row[k] = await (0, _dataHelpers.serializeCellValue)(context, {
                            value: v,
                            column: col,
                            siteUrl: param.ncSiteUrl
                        });
                        includedColumns.push({
                            col,
                            viewOrder: (_ref = (_viewCols_find = viewCols.find((vCol)=>vCol.fk_column_id === col.id)) == null ? void 0 : _viewCols_find.order) != null ? _ref : includedColumns.length + 1
                        });
                    }
                }
            }
            const orderedColumns = includedColumns.sort((a, b)=>a.viewOrder - b.viewOrder);
            return {
                data: data.map((row)=>{
                    return orderedColumns.reduce((acc, cur)=>{
                        acc[cur.col.title] = row[cur.col.title];
                        return acc;
                    }, {});
                })
            };
        };
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const limit = 200;
        const offset = 0;
        try {
            await this.recursiveReadForExcel(context, formatAndSerialize, baseModel, dataStream, model, view, offset, limit, fields, {
                filterArrJson: param.filterArrJson,
                sortArrJson: param.sortArrJson
            });
        } catch (e) {
            this.debugLog(e);
            throw e;
        }
    }
    async recursiveReadForExcel(context, formatter, baseModel, stream, model, view, offset, limit, fields, param, allRows = [], headers = []) {
        const result = await this.datasService.dataList(context, {
            model,
            view,
            query: {
                limit,
                offset,
                fields,
                filterArrJson: param == null ? void 0 : param.filterArrJson,
                sortArrJson: param == null ? void 0 : param.sortArrJson
            },
            baseModel,
            ignoreViewFilterAndSort: false,
            limitOverride: limit,
            skipSortBasedOnOrderCol: true
        });
        if (result.list.length === 0 && offset === 0) {
            // Empty result - generate Excel with just headers
            const workbook = _xlsx.utils.book_new();
            const worksheet = _xlsx.utils.aoa_to_sheet([
                fields
            ]);
            _xlsx.utils.book_append_sheet(workbook, worksheet, 'Data');
            const excelBuffer = _xlsx.write(workbook, {
                type: 'buffer',
                bookType: 'xlsx'
            });
            stream.push(excelBuffer);
            stream.push(null);
            return;
        }
        const { data } = await formatter(result.list);
        // Capture headers from the first batch (preserves view column order)
        if (offset === 0 && data.length > 0) {
            headers.push(...Object.keys(data[0]));
        }
        allRows.push(...data);
        if (result.pageInfo.isLastPage) {
            // All data collected — generate Excel workbook
            const workbook = _xlsx.utils.book_new();
            const worksheet = _xlsx.utils.json_to_sheet(allRows, {
                header: headers
            });
            _xlsx.utils.book_append_sheet(workbook, worksheet, 'Data');
            const excelBuffer = _xlsx.write(workbook, {
                type: 'buffer',
                bookType: 'xlsx'
            });
            stream.push(excelBuffer);
            stream.push(null);
        } else {
            await this.recursiveReadForExcel(context, formatter, baseModel, stream, model, view, offset + limit, limit, fields, param, allRows, headers);
        }
    }
    async recursiveReadForJson(context, formatter, baseModel, stream, model, view, offset, limit, fields, isFirst = false, param) {
        const result = await this.datasService.dataList(context, {
            model,
            view,
            query: {
                limit,
                offset,
                fields,
                filterArrJson: param == null ? void 0 : param.filterArrJson,
                sortArrJson: param == null ? void 0 : param.sortArrJson
            },
            baseModel,
            ignoreViewFilterAndSort: false,
            limitOverride: limit,
            skipSortBasedOnOrderCol: true
        });
        if (result.list.length === 0 && offset === 0) {
            // Empty result, just return empty array
            stream.push('[]');
            stream.push(null);
            return;
        }
        const { data } = await formatter(result.list);
        if (isFirst) {
            // Start JSON array
            stream.push('[\n');
        }
        if (data.length > 0) {
            // Add comma if not the first batch
            if (offset > 0) {
                stream.push(',\n');
            }
            // Write JSON objects
            const jsonRows = data.map((row)=>JSON.stringify(row)).join(',\n');
            stream.push(jsonRows);
        }
        if (result.pageInfo.isLastPage) {
            // Close JSON array
            stream.push('\n]');
            stream.push(null);
        } else {
            await this.recursiveReadForJson(context, formatter, baseModel, stream, model, view, offset + limit, limit, fields, false, param);
        }
    }
    filterOutCrossBaseColumns(model) {
        const crossbaseLinkIds = new Set(model.columns.filter((c)=>(0, _nocodbsdk.isCrossBaseLink)(c)).map((c)=>c.id));
        // filter out cross base link columns and any Lookup or Rollup columns which is dependent on cross base link
        return model.columns.filter((c)=>!(0, _nocodbsdk.isCrossBaseLink)(c) && [
                _nocodbsdk.UITypes.Lookup,
                _nocodbsdk.UITypes.Rollup
            ].includes(c.uidt) ? !crossbaseLinkIds.has(c.colOptions.fk_relation_column_id) : true);
    }
    async recursiveRead(context, formatter, baseModel, stream, model, view, offset, limit, fields, header = false, delimiter = ',', dataExportMode = false, param) {
        return new Promise((resolve, reject)=>{
            this.datasService.dataList(context, {
                model,
                view,
                query: {
                    limit,
                    offset,
                    fields,
                    filterArrJson: param == null ? void 0 : param.filterArrJson,
                    sortArrJson: param == null ? void 0 : param.sortArrJson
                },
                baseModel,
                ignoreViewFilterAndSort: !dataExportMode,
                limitOverride: limit,
                skipSortBasedOnOrderCol: true
            }).then((result)=>{
                if (result.list.length === 0 && offset === 0) {
                    return (0, _dbHelpers.getQueriedColumns)(context, {
                        model,
                        view,
                        fieldsSet: new Set(fields)
                    }).then((columns)=>{
                        stream.push((0, _papaparse.unparse)([
                            columns.map((col)=>col.title)
                        ], {
                            header: true
                        }));
                        stream.push(null);
                        resolve();
                    });
                }
                try {
                    if (!header) {
                        stream.push('\r\n');
                    }
                    // check if formatter is async
                    const formatterPromise = formatter(result.list);
                    if (formatterPromise instanceof Promise) {
                        formatterPromise.then(({ data })=>{
                            stream.push((0, _papaparse.unparse)(data, {
                                header,
                                delimiter
                            }));
                            if (result.pageInfo.isLastPage) {
                                stream.push(null);
                                resolve();
                            } else {
                                this.recursiveRead(context, formatter, baseModel, stream, model, view, offset + limit, limit, fields, false, delimiter, dataExportMode).then(resolve).catch(reject);
                            }
                        });
                    } else {
                        stream.push((0, _papaparse.unparse)(formatterPromise.data, {
                            header
                        }));
                        if (result.pageInfo.isLastPage) {
                            stream.push(null);
                            resolve();
                        } else {
                            this.recursiveRead(context, formatter, baseModel, stream, model, view, offset + limit, limit, fields, false, delimiter, dataExportMode).then(resolve).catch(reject);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }).catch(reject);
        });
    }
    async recursiveLinkRead(context, formatter, baseModel, linkStream, model, view, offset, limit, fields, header = false) {
        return new Promise((resolve, reject)=>{
            this.datasService.getDataList(context, {
                model,
                view,
                query: {
                    limit,
                    offset,
                    fields
                },
                baseModel,
                ignoreViewFilterAndSort: true,
                limitOverride: limit,
                apiVersion: _nocodbsdk.NcApiVersion.V1,
                skipSortBasedOnOrderCol: true
            }).then((result)=>{
                try {
                    if (!header) {
                        linkStream.push('\r\n');
                    }
                    const { data } = formatter(result.list);
                    if (data) linkStream.push((0, _papaparse.unparse)(data, {
                        header
                    }));
                    if (result.pageInfo.isLastPage) {
                        resolve();
                    } else {
                        this.recursiveLinkRead(context, formatter, baseModel, linkStream, model, view, offset + limit, limit, fields).then(resolve).catch(reject);
                    }
                } catch (e) {
                    reject(e);
                }
            }).catch(reject);
        });
    }
    async exportBase(context, param) {
        const hrTime = (0, _helpers.initTime)();
        const source = await _models.Source.get(context, param.sourceId);
        if (!source) _catchError.NcError.sourceNotFound(param.sourceId);
        const base = await _models.Base.get(context, source.base_id);
        const models = (await source.getModels(context)).filter(// TODO revert this when issue with cache is fixed
        (m)=>m.source_id === source.id && !m.mm && m.type === 'table');
        const { serializedModels: exportedModels } = await this.serializeModels(context, {
            modelIds: models.map((m)=>m.id)
        });
        (0, _helpers.elapsedTime)(hrTime, `serialize models for ${source.base_id}::${source.id}`, 'exportBase');
        const exportData = {
            id: `${base.id}::${source.id}`,
            models: exportedModels
        };
        const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
        const destPath = `export/${base.id}/${source.id}/${param.path}`;
        try {
            const readableStream = new _stream.Readable({
                read () {}
            });
            readableStream.setEncoding('utf8');
            readableStream.push(JSON.stringify(exportData));
            readableStream.push(null);
            await storageAdapter.fileCreateByStream(`${destPath}/schema.json`, readableStream);
            const handledMmList = [];
            const combinedLinkStream = new _stream.Readable({
                read () {}
            });
            const uploadLinkPromise = storageAdapter.fileCreateByStream(`${destPath}/data/links.csv`, combinedLinkStream);
            for (const model of models){
                const dataStream = new _stream.Readable({
                    read () {}
                });
                const linkStream = new _stream.Readable({
                    read () {}
                });
                const linkPromise = new Promise((resolve)=>{
                    linkStream.on('data', (chunk)=>{
                        combinedLinkStream.push(chunk);
                    });
                    linkStream.on('end', ()=>{
                        combinedLinkStream.push('\r\n');
                        resolve(null);
                    });
                    linkStream.on('error', (e)=>{
                        this.debugLog(e);
                        resolve(null);
                    });
                });
                const uploadPromise = storageAdapter.fileCreateByStream(`${destPath}/data/${model.id}.csv`, dataStream);
                let error = null;
                this.streamModelDataAsCsv(context, {
                    dataStream,
                    linkStream,
                    baseId: base.id,
                    modelId: model.id,
                    handledMmList
                }).catch((e)=>{
                    this.debugLog(e);
                    dataStream.push(null);
                    linkStream.push(null);
                    error = e;
                });
                await Promise.all([
                    uploadPromise,
                    linkPromise
                ]);
                if (error) throw error;
            }
            combinedLinkStream.push(null);
            await uploadLinkPromise;
            (0, _helpers.elapsedTime)(hrTime, `export source ${source.base_id}::${source.id}`, 'exportBase');
        } catch (e) {
            _catchError.NcError.get(context).badRequest(e);
        }
        return {
            path: destPath
        };
    }
    constructor(datasService){
        this.datasService = datasService;
        this.debugLog = (0, _debug.default)('nc:jobs:import');
    }
};
ExportService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService
    ])
], ExportService);
